export const phoneNUmberRegexValidation = (value: any): boolean => {
  return /^\+?\d+$/.test(value);
};

export const iremboExtraCountryValidationsConfig: Record<
  string,
  TIremboExtraCountryValidations
> = {
  rw: {
    minLength: 9,
    maxLength: 9,
  },
};

export type TIremboExtraCountryValidations = {
  minLength?: number;
  maxLength?: number;
  regex?: RegExp;
};
